"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleFragments = exports.reserveDetailsFragment = exports.vehicleConfigurationFragment = exports.vehicleOrderStatusFragment = exports.vehicleStockFragment = exports.vehicleStatusFragment = exports.vehicleInventoryFragment = exports.vehicleOptionFragment = exports.vehicleModelFragment = exports.vehicleFragmentFull = exports.vehicleFragmentMinimal = exports.vehicleFragment = void 0;
const reference_1 = require("./reference");
exports.vehicleFragment = `
  fragment vehicle on Vehicle {
    id
    config {
      ...vehicleConfiguration
    }
    estimatedDeliveryDate  
    inventory {
      ...vehicleInventory
    }
    isDeliveryTimeUncertain
    latestDeliveryDate 
    make
    model {
      ...vehicleModel
    }
    orderFromFactoryDetails{
      color
      colorPrice
      expectedProductionDate 
      interiorCode
      interiorPrice
      totalPrice
     }
    price
    reference {
      ...reference
    }
    serialNo
    specificationDescription
    status {
      ...vehicleStatus
    }
    timestamp
    vin 
  }
`;
exports.vehicleFragmentMinimal = `
  fragment vehicle on Vehicle {
    id
    estimatedDeliveryDate
    isDeliveryTimeUncertain
    latestDeliveryDate
    make
    model {
      ...vehicleModel
    }
    orderFromFactoryDetails{
      color
      colorPrice
      expectedProductionDate 
      interiorCode
      interiorPrice
      totalPrice
     }
    price
    reference {
      ...reference
    }
    serialNo
    specificationDescription
    timestamp
    vin  
    }
`;
exports.vehicleFragmentFull = `
  fragment vehicle on Vehicle {
    id
    calculations {
      id
    }
    config {
      ...vehicleConfiguration
    }
    estimatedDeliveryDate
    inventory {
      ...vehicleInventory
    }
    make
    mileage
    model {
      ...vehicleModel
    }
    name
    order {
      id
    }
    orderFromFactoryDetails{
      color
      colorPrice
      expectedProductionDate 
      interiorCode
      interiorPrice
      totalPrice
     }
    price
    priceExcludingVat
    reference {
      ...reference
    }
    registrationNumber
    serialNo
    series
    specificationDescription
    status {
      ...vehicleStatus
    }
    stock {
      ...vehicleStock
    }
    timestamp
    tradeIn {
    ...contract
    }
    user {
      reference {
        bosApiId
      }
    }
    vehicleLine {
      code
      name
    }
    vin  
    }
`;
exports.vehicleModelFragment = `
  fragment vehicleModel on Model {
    id
    code
    description
    name
    type
    version
  }
`;
exports.vehicleOptionFragment = `
  fragment vehicleOption on VehicleOption {
    description
    id
    name
    price
    priceExcludingVat
  }
`;
exports.vehicleInventoryFragment = `
  fragment vehicleInventory on VehicleInventory {
    interiorHexCode
    isReserved
    isSecondHandVehicle
    location
    locationName
    make
    model
    price
    reservedToDateTime
    salesPackages
    serialNumber
    series
    trackAndTrace
    varnishHexCode
    vin
  }
`;
exports.vehicleStatusFragment = `
  fragment vehicleStatus on BosApiVehicleStatus {
    bodyStyle
    color
    engineType
    importerLocation
    registrationNo
    site
    trackTraceCode
  }
`;
exports.vehicleStockFragment = `
  fragment vehicleStock on BosApiVehicleStock {
    colorMainDescription
    colorMainId
    daysOnStock
    isReserved
    stockAvailabilityCode
  }
`;
exports.vehicleOrderStatusFragment = `
  fragment orderStatus on BosVehicleOrderStatus {
    customerId
    dealerId
    ifsCustomerId
    orderNumber
    orderType
    quotationNumber
    reservationFromDate
    reservationToDate
    repurchaseContractId
    status
    statusMessage
    timestamp
    vehicleId
    vehicleOrderId
  }
`;
exports.vehicleConfigurationFragment = `
  fragment vehicleConfiguration on VehicleConfiguration {
    id
    name
    price
    priceExcludingVat
    sku
    images {
      height
      width
      url
    }
    interiors {
      additionalPrice
      interiorCode
      name
      type
    }
    salesPackages {
      additionalPrice
      equipment
      id
      name
    }
    optionPackages {
      additionalPrice
      equipment
      id
      name
    }
    varnishes {
      additionalPrice
      hexCode
      name
      type
      varnishCode
    }
  }
`;
exports.reserveDetailsFragment = `
  fragment reserveDetails on ReserveDetails {
    id
    quotationNumber
    reservationFromDate
    reservationToDate
    vehicleReserveStatus
  }
`;
exports.vehicleFragments = `
  ${reference_1.referenceFragment}
  ${exports.vehicleFragment}
  ${exports.vehicleConfigurationFragment}
  ${exports.vehicleModelFragment}
  ${exports.vehicleStatusFragment}
  ${exports.vehicleInventoryFragment}
  `;
//# sourceMappingURL=vehicle.js.map